<template>
  <div
    class="tw-rounded-2xl tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-100 dark:tw-border-slate-700 tw-shadow tw-py-3.5 tw-px-4 tw-flex tw-flex-col tw-gap-3"
  >
    <div
      class="tw-text-sm tw-text-slate-700 dark:tw-text-slate-50 tw-font-body tw-font-medium"
    >
      {{ props.title }} Over Time
    </div>
    <div class="tw-flex tw-items-center tw-gap-2">
      <div
        class="tw-w-[9px] tw-aspect-square tw-rounded-full tw-bg-violet-500 dark:tw-bg-green-400"
      ></div>
      <div
        class="tw-text-xs tw-font-medium tw-text-slate-600 dark:tw-text-slate-300"
      >
        {{ props.title }}
      </div>
    </div>
    <div class="tw-relative">
      <template v-if="props.loading">
        <div class="tw-flex tw-items-center tw-justify-center tw-h-[200px]">
          <LoaderSm />
        </div>
      </template>
      <template v-else-if="hasChartData">
        <line-chart
          :data="chartData"
          :colors="[chartColor]"
          height="200px"
          :curve="true"
          :points="true"
          :legend="false"
          :labels="{ fontSize: 12 }"
        />
      </template>
      <div
        v-else
        class="tw-flex tw-items-center tw-justify-center tw-h-[200px] tw-text-sm tw-text-slate-500 dark:tw-text-slate-300 tw-font-medium tw-font-body"
      >
        Show data populating...
      </div>
    </div>
  </div>
</template>

<script setup>
import LoaderSm from "@/components/LoaderSm.vue";
import moment from "moment";
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps(["title", "data", "loading"]);

const chartKeyMap = {
  Reach: "views",
  Sessions: "plays",
  Impressions: "impressions",
  Revenue: "revenue",
};

const chartData = computed(() => {
  let items = {};
  props.data.forEach((item) => {
    const parsedDate = moment.utc(item.date);
    // Keep full date so chart library doesn't default to 2001 when year is missing
    const date = parsedDate.isValid()
      ? parsedDate.format("YYYY-MM-DD")
      : item.date;
    const keyMap = {
      Reach: "views",
      Sessions: "plays",
      Impressions: "impressions",
      Revenue: "revenue",
    };
    const key = keyMap[props.title] || "views";
    items[date] = item[key];
  });
  return items;
});

const hasChartData = computed(() => {
  if (!Array.isArray(props.data) || props.data.length === 0) return false;
  const key = chartKeyMap[props.title] || "views";
  return props.data.some(
    (item) => item[key] !== null && item[key] !== undefined
  );
});

const chartColor = computed(() => {
  return store.getters.currentTheme == "dark" ? "#4ADE80" : "#8B5CF6";
});
</script>
